module.exports = __webpack_public_path__ + "img/quick-header.e4a16097.png";